import { SyntheticEvent } from 'react';
import styled from '@emotion/styled';

import TextField from 'presentations/views/components/atoms/TextField';
import Icon from 'presentations/views/components/atoms/Icon';

import { fontSize, spacing } from 'presentations/views/styles';
import { gray01 } from 'presentations/views/styles/color';
import TimeZone from 'domains/models/time_zone';

type Props = {
  isLoading: boolean;
  timeZone: string;
  timeZones: TimeZone[];
  onClick: (e: SyntheticEvent<HTMLDivElement>) => void;
  color: string;
};

export default function Component(props: Props) {
  return (
    <StyledContainer onClick={props.onClick}>
      {!props.isLoading && <StyledTimeZoneIcon name="access_time" />}
      <TimeZoneSelect
        width={160}
        isLoading={props.isLoading}
        name="timeZone"
        size="small"
        variant="standard"
        value={props.timeZone}
        color={props.color}
      />
    </StyledContainer>
  );
}

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
`;
const StyledTimeZoneIcon = styled(Icon)`
  color: ${gray01};
  margin-right: ${spacing(8)};
  font-size: ${fontSize(18)};
`;
const TimeZoneSelect = styled(TextField)<{ color: string }>`
  border: 0;
  width: 160px;
  color: ${gray01};
  font-size: ${fontSize(14)};
  .MuiInput-underline:before {
    border: 0;
  }
  .MuiInput-underline:after {
    border-color: ${({ color }) => color};
  }
`;
